import { useContext } from 'react';
import { PostHogContext } from 'contexts/PostHogContext';

const usePostHog = () => useContext(PostHogContext);

export default usePostHog;
